import {AI_PROMO_STATUSES} from '../../configs/aiMatch';

const KNOWN_STATUSES = new Set(Object.values(AI_PROMO_STATUSES));

const toTimestamp = (value) => (
  typeof value === 'number' && Number.isFinite(value) ? value : null
);

const toCount = (value) => (
  typeof value === 'number' && Number.isFinite(value) && value >= 0 ? Math.floor(value) : 0
);

/**
 * Данные промо-лобби с ИИ в одном виде — из дескриптора лобби (aiPromo) и из
 * GET /api/ai-promo/today. Сервер мог быть старше клиента или ответить
 * частично: неизвестный статус и нечисловые времена превращаются в null, а
 * не роняют интерфейс. lobbyId есть только в ответе эндпоинта.
 * Возвращает null, если промо-лобби нет.
 */
export const normalizeAiPromo = (raw) => {
  if (!raw || typeof raw !== 'object') return null;
  const lobbyId = typeof raw.lobbyId === 'string' && raw.lobbyId ? raw.lobbyId : null;
  if ('lobbyId' in raw && !lobbyId) return null;
  const status = KNOWN_STATUSES.has(raw.status) ? raw.status : null;
  if (!status) return null;
  return {
    lobbyId,
    status,
    opensAt: toTimestamp(raw.opensAt),
    startAt: toTimestamp(raw.startAt),
    projectedStartAt: toTimestamp(raw.projectedStartAt),
    latestStartAt: toTimestamp(raw.latestStartAt),
    cutoffAt: toTimestamp(raw.cutoffAt),
    liveCount: toCount(raw.liveCount),
    maxPlayers: toCount(raw.maxPlayers),
    spectatorsCount: toCount(raw.spectatorsCount),
  };
};
